@charset "UTF-8";

/* src/app/modules/print-cards/components/cards/card-content/business-cards-2x3/plantlife/plantlife-business-card-stack-content/plantlife-business-card-stack-content.component.scss */
.f12px {
  font-size: 0.75rem;
}
.f14px {
  font-size: 0.875rem;
}
.f16px {
  font-size: 1rem;
}
.f18px {
  font-size: 1.125rem;
}
.f20px {
  font-size: 1.25rem;
}
.f24px {
  font-size: 1.5rem;
}
.f32px {
  font-size: 2rem;
}
.f48px {
  font-size: 3rem;
}
.f64px {
  font-size: 4rem;
}
.content-area {
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  padding: 0.625rem;
}
.content-area .content {
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.content-area .content .card-header {
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: bebas-neue-pro, sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 0.875rem;
  overflow: clip;
  overflow-clip-margin: 0.1rem;
  text-overflow: ellipsis;
  white-space: normal;
  display: -webkit-box;
  word-break: break-word;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  text-align: center;
  border: 3px solid #000000;
  min-height: 1rem;
}
.content-area .content .card-identification-area {
  box-sizing: border-box;
  width: 100%;
  height: 5.25rem;
  display: flex;
  flex-direction: column;
  position: relative;
}
.content-area .content .card-identification-area .background-content {
  position: absolute;
  inset: 0;
  z-index: -1;
}
.content-area .content .card-identification-area .background-content .print-card-background-asset {
  box-sizing: border-box;
  height: 100%;
  width: 100%;
}
.content-area .content .card-identification-area .id-info {
  width: 100%;
  box-sizing: border-box;
  padding: 0.25rem 0.375rem 0.1875rem 0.375rem;
  height: 5.25rem;
  border-left: 3px solid #000000;
  border-right: 3px solid #000000;
}
.content-area .content .card-identification-area .id-info .split-logo {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  box-sizing: border-box;
  height: 100%;
  flex: 1;
}
.content-area .content .card-identification-area .id-info .split-logo .left-side {
  display: flex;
  flex-direction: row;
  gap: 0.5625rem;
}
.content-area .content .card-identification-area .id-info .split-logo .left-side .strain {
  font-family: bebas-neue-pro-expanded, sans-serif;
  font-weight: 700;
  font-style: normal;
  font-size: 1rem;
  margin-top: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1.5rem;
  height: 1.5rem;
  color: #ffffff;
}
.content-area .content .card-identification-area .id-info .split-logo .left-side .title-brand-label-top-terpene {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.content-area .content .card-identification-area .id-info .split-logo .left-side .title-brand-label-top-terpene .title-brand-label {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.content-area .content .card-identification-area .id-info .split-logo .left-side .title-brand-label-top-terpene .title-brand-label .product-title {
  font-size: 1.375rem;
  font-family: bebas-neue-pro, sans-serif;
  font-weight: 600;
  font-style: normal;
  white-space: normal;
  line-height: 90%;
}
.content-area .content .card-identification-area .id-info .split-logo .left-side .title-brand-label-top-terpene .title-brand-label .product-brand-and-label {
  display: flex;
  flex-direction: row;
  gap: 0.375rem;
}
.content-area .content .card-identification-area .id-info .split-logo .left-side .title-brand-label-top-terpene .title-brand-label .product-brand-and-label .product-brand {
  overflow: clip;
  overflow-clip-margin: 0.1rem;
  text-overflow: ellipsis;
  white-space: normal;
  display: -webkit-box;
  word-break: break-word;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  font-size: 1rem;
  font-family: bebas-neue-pro, sans-serif;
  font-weight: 400;
  font-style: normal;
  line-height: 113%;
}
.content-area .content .card-identification-area .id-info .split-logo .left-side .title-brand-label-top-terpene .title-brand-label .product-brand-and-label .label {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 0.3125rem;
}
.content-area .content .card-identification-area .id-info .split-logo .left-side .title-brand-label-top-terpene .title-brand-label .product-brand-and-label .label .print-card-label {
  height: fit-content;
  margin: 0;
  padding: 0;
}
.content-area .content .card-identification-area .id-info .split-logo .left-side .title-brand-label-top-terpene .title-brand-label .product-brand-and-label .label .print-card-label ::ng-deep .product-label {
  font-family: bebas-neue-pro, sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 0.5625rem;
  padding: 1px 3px;
  border-radius: 2px;
  margin: 0;
  width: fit-content;
  line-height: 1.4;
}
.content-area .content .card-identification-area .id-info .split-logo .left-side .title-brand-label-top-terpene .top-terpene {
  display: flex;
  flex-direction: row;
  border: 1px solid #000000;
  width: fit-content;
}
.content-area .content .card-identification-area .id-info .split-logo .left-side .title-brand-label-top-terpene .top-terpene .label {
  font-family: bebas-neue-pro-expanded, sans-serif;
  font-weight: 700;
  font-style: normal;
  font-size: 0.625rem;
  text-transform: uppercase;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #98cc5c;
  color: #ffffff;
  padding: 0.125rem 0 0.1875rem 0;
  border-right: 1px solid #000000;
  width: 3.375rem;
}
.content-area .content .card-identification-area .id-info .split-logo .left-side .title-brand-label-top-terpene .top-terpene .value {
  font-family: bebas-neue-pro, sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 0.625rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  color: #222222;
  padding: 0.125rem 0 0.1875rem 0;
  min-width: 5rem;
}
.content-area .content .card-identification-area .id-info .split-logo .brand-logo-and-badges {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
  width: 3.125rem;
}
.content-area .content .card-identification-area .id-info .split-logo .brand-logo-and-badges .brand-logo {
  height: 3.125rem;
  width: 3.125rem;
  object-fit: contain;
}
.content-area .content .card-identification-area .id-info .split-logo .brand-logo-and-badges .badges {
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 0.5rem;
}
.content-area .content .card-information-table {
  display: flex;
  overflow-y: visible;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  height: 2rem;
  border-left: 3px solid #000000;
  border-right: 3px solid #000000;
  border-bottom: 3px solid #000000;
}
.content-area .content .card-information-table .table-data {
  width: 100%;
}
.content-area .content .card-information-table .table-data .table-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.content-area .content .card-information-table .table-data .table-row .property-container,
.content-area .content .card-information-table .table-data .table-row .non-property-container {
  display: flex;
  flex-direction: row;
}
.content-area .content .card-information-table .table-data .table-row .property-container .table-cell,
.content-area .content .card-information-table .table-data .table-row .non-property-container .table-cell {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2.25rem;
  color: #ffffff;
  text-align: center;
}
.content-area .content .card-information-table .table-data .table-row .property-container .non-property-cell,
.content-area .content .card-information-table .table-data .table-row .non-property-container .non-property-cell {
  width: 2.75rem;
}
.content-area .content .card-information-table .table-data .table-header {
  background-color: #98cc5c;
  border-top: 1px solid #000000;
  border-bottom: 1px solid #000000;
  height: 0.875rem;
}
.content-area .content .card-information-table .table-data .table-header .property-container .table-header-cell,
.content-area .content .card-information-table .table-data .table-header .non-property-container .table-header-cell {
  font-family: bebas-neue-pro, sans-serif;
  font-weight: 600;
  font-style: normal;
  font-size: 0.625rem;
  line-height: 0.625rem;
  text-transform: uppercase;
  color: #ffffff;
}
.content-area .content .card-information-table .table-data .table-body {
  background-color: #ffffff;
  height: 1rem;
}
.content-area .content .card-information-table .table-data .table-body .property-container .table-body-cell,
.content-area .content .card-information-table .table-data .table-body .non-property-container .table-body-cell {
  font-family: bebas-neue-pro, sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 0.75rem;
  color: #000000;
  line-height: 0.75rem;
}
.content-area .content .card-information-table .accessory-price {
  width: 100%;
  padding-right: 0.375rem;
}
.content-area .content .card-information-table .accessory-price ::ng-deep .product-variant-price {
  overflow: clip;
  overflow-clip-margin: 0.08rem;
  text-overflow: ellipsis;
  white-space: normal;
  display: -webkit-box;
  word-break: break-word;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  font-size: 2.5rem;
  font-family: bebas-neue-pro, sans-serif;
  font-weight: 600;
  font-style: normal;
  line-height: 90%;
  color: black;
  margin-right: 0.375rem;
  padding-bottom: 0.375rem;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 0.25rem;
}
.content-area .product-badge {
  height: 0.8125rem;
  width: auto;
  object-fit: contain;
}
.content-area ::ng-deep .card-regular-price .product-variant-current-price.and-has-previous-price {
  display: none;
}
.content-area ::ng-deep .force-bold-style * {
  font-family: bebas-neue-pro-expanded, sans-serif;
  font-weight: 700;
  font-style: normal;
}
.content-area ::ng-deep .force-italic-style * {
  font-family: bebas-neue-pro-expanded, sans-serif;
  font-weight: 700;
  font-style: italic;
}
/*# sourceMappingURL=plantlife-business-card-stack-content.component.css.map */
